import React from 'react';
import { useResponseStatusSnapshots } from '../../workAvailability/ResponseStatusProvider';
import './ChatWorkAvailabilityNotices.css';

type WorkAvailabilityNotice = {
  id?: string;
  status?: string;
  responseStatus?: string;
  recipientAdminId?: number | string | null;
  recipient_admin_id?: number | string | null;
  nextWorkStartAt?: string | null;
  next_work_start_at?: string | null;
};

type MessageWithWorkAvailabilityNotices = {
  work_availability_notices?: WorkAvailabilityNotice[];
  workAvailabilityNotices?: WorkAvailabilityNotice[];
};

type StatusSnapshot = Record<number, { status?: string } | undefined>;
const DELAY_STATUSES = new Set(['unavailable', 'slow_response', 'off_duty']);

export function activeWorkAvailabilityNotices(notices: WorkAvailabilityNotice[], badges: StatusSnapshot) {
  return notices.filter((notice) => {
    const adminId = Number(notice.recipientAdminId ?? notice.recipient_admin_id);
    if (!Number.isSafeInteger(adminId) || adminId < 1 || !badges[adminId]) return true;
    return DELAY_STATUSES.has(String(badges[adminId]?.status || ''));
  });
}

export default function ChatWorkAvailabilityNotices({ message }: { message?: MessageWithWorkAvailabilityNotices | null }) {
  const notices = Array.isArray(message?.work_availability_notices)
    ? message.work_availability_notices
    : (Array.isArray(message?.workAvailabilityNotices) ? message.workAvailabilityNotices : []);
  const badges = useResponseStatusSnapshots(notices.map(notice => notice.recipientAdminId ?? notice.recipient_admin_id));
  const activeNotices = activeWorkAvailabilityNotices(notices, badges);
  if (!activeNotices.length) return null;
  const hasSlowResponse = activeNotices.some((notice) => {
    const adminId = Number(notice.recipientAdminId ?? notice.recipient_admin_id);
    const currentStatus = Number.isSafeInteger(adminId) ? badges[adminId]?.status : undefined;
    return ['unavailable', 'slow_response'].includes(currentStatus || notice.responseStatus || '');
  });
  return (
    <div className="chat-work-availability-notice" role="status">
      <span>{hasSlowResponse
        ? 'メンションした担当者は現在すぐに対応できないため、返信が遅れる場合があります。'
        : 'メンションした担当者は業務時間外のため、返信が遅れる場合があります。'}</span>
    </div>
  );
}
